/* eslint-disable react/require-default-props */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import RenderServices from 'components/atoms/render_services';
import FeaturedConlicitasegCard from 'components/atoms/featured_conlicitaseg_card';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import SetaDown from 'assets/images/seta_down.svg';
import SetaUp from 'assets/images/seta_up.svg';
import { PanelState, shortcuts } from 'store/modules/panel_store/types';
import createTrack from 'services/actions/tracker_actions';
import { canSeeTool, canUseRepresentantPlatform } from 'services/alfa_tools';
import { FALLBACK_CONLICITASEG_TOOL, isConlicitasegTool } from 'services/conlicitaseg_tool';
import { REPRESENTANT_DASHBOARD_TOOLS } from 'services/representant_tools';
// import OpenTutorial from 'components/atoms/open_tutorial';
import { Container } from './styles';

interface OurToolsProps {
  featuredTool?: boolean;
}

const OurTools: React.FC<OurToolsProps> = ({ featuredTool = false }) => {
  const { panel, request } = useSelector<ApplicationState, PanelState>(
    (state) => state.session.panel,
  );
  const [allTools, setAllTools] = useState<boolean>(false);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const [selectedServices, setSelectedServices] = useState<shortcuts[]>([]);

  useEffect(() => {
    if (request?.loaded && panel?.list_tools_shortcuts) {
      setSelectedServices(
        panel.list_tools_shortcuts
          .filter((service) => canSeeTool(service, profile))
          .map((service) => ({ ...service })),
      );
    }
  }, [
    request?.loaded,
    panel?.list_tools_shortcuts,
    profile?.alfa_tester,
    profile?.clientId,
    profile?.ambassador,
  ]);

  const conlicitasegTool = useMemo<shortcuts>(
    () => selectedServices.find(isConlicitasegTool) ?? FALLBACK_CONLICITASEG_TOOL,
    [selectedServices],
  );

  const gestaoServices = useMemo(
    () =>
      selectedServices
        .filter((service) => service.category === 'Ferramentas de Gestão')
        .filter((service) => !featuredTool || !isConlicitasegTool(service)),
    [featuredTool, selectedServices],
  );

  return (
    <Container>
      <div className="d-flex">
        <h4 className="pt-3 mr-3">Nossas Ferramentas</h4>
        {/* {!panel?.course_released && (
          <div className="d-md-flex d-block align-items-center py-3">
            <OpenTutorial type="modal" source="dashboard" />
          </div>
        )} */}
      </div>
      {canUseRepresentantPlatform(profile) && (
        <div className="row">
          <div className="col-12 mb-4">
            <div className="bg-white p-4 rounded-3 shadow-categories representant-tools">
              <RenderServices
                categoryName="Ferramentas do Representante"
                serviceList={REPRESENTANT_DASHBOARD_TOOLS}
              />
            </div>
          </div>
        </div>
      )}
      {featuredTool && (
        <div className="featured-tool mb-4" data-testid="featured-tool">
          <FeaturedConlicitasegCard toolName={conlicitasegTool.name} />
        </div>
      )}
      <div className="row">
        <div className="col-12 col-md-6 mb-4">
          <div className="bg-white p-4 rounded-3 shadow-categories">
            <RenderServices
              categoryName="Oportunidades de Negócio"
              serviceList={selectedServices.filter(
                (service) => service.category === 'Oportunidades de Negócio',
              )}
            />
          </div>
        </div>
        <div className="col-12 col-md-6 mb-4">
          <div className="bg-ia p-4 rounded-3 shadow-categories">
            <RenderServices
              categoryName="Inteligência Artificial"
              serviceList={selectedServices.filter(
                (service) => service.category === 'Inteligência Artificial',
              )}
            />
          </div>
        </div>
        <div className="col-12 col-md-6 mb-4">
          <div className="bg-white p-4 rounded-3 shadow-categories">
            <RenderServices categoryName="Ferramentas de Gestão" serviceList={gestaoServices} />
          </div>
        </div>
        <div className="col-12 col-md-6 mb-4">
          <div className="bg-white p-4 rounded-3 shadow-categories">
            <RenderServices
              categoryName="Ferramentas de Automação"
              serviceList={selectedServices.filter(
                (service) => service.category === 'Ferramentas de Automação',
              )}
            />
          </div>
        </div>
      </div>
      {allTools && (
        <>
          <div className="row mt-2">
            <div className="col-12 col-md-6 mb-4">
              <div className="bg-white p-4 rounded-3 shadow-categories">
                <RenderServices
                  categoryName="Análise Estratégica"
                  serviceList={selectedServices.filter(
                    (service) => service.category === 'Análise Estratégica',
                  )}
                />
              </div>
            </div>
            <div className="col-12 col-md-6 mb-4">
              <div className="bg-white p-4 rounded-3 shadow-categories">
                <RenderServices
                  categoryName="Assessoria e Consultoria"
                  serviceList={selectedServices.filter(
                    (service) => service.category === 'Assessoria e Consultoria',
                  )}
                />
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-12 col-md-4 mb-4">
              <div className="bg-white p-4 rounded-3 shadow-categories">
                <RenderServices
                  categoryName="Treinamento e Capacitação"
                  serviceList={selectedServices.filter(
                    (service) => service.category === 'Treinamento e Capacitação',
                  )}
                />
              </div>
            </div>
            <div className="col-12 col-md-8 mb-4">
              <div className="bg-white p-4 rounded-3 shadow-categories">
                <RenderServices
                  categoryName="Outras Ferramentas"
                  serviceList={selectedServices.filter(
                    (service) => service.category === 'Outras Ferramentas',
                  )}
                />
              </div>
            </div>
          </div>
        </>
      )}
      <div className="text-center p-0">
        <button
          type="button"
          className="btn btn-link border-0"
          onClick={() => {
            createTrack('Dashboard - Clicou em todas as ferramentas');
            setAllTools(!allTools);
          }}
        >
          {allTools ? (
            <>
              <span>Esconder todas as ferramentas</span>
              <img className="px-2 nav-arrow" alt="Esconder todas as ferramentas" src={SetaUp} />
            </>
          ) : (
            <>
              <span>Ver todas as ferramentas</span>
              <img className="px-2 nav-arrow" alt="Ver todas as ferramentas" src={SetaDown} />
            </>
          )}
        </button>
      </div>
    </Container>
  );
};

export default OurTools;
